import React from "react";
import "./styles/inputField.css";

export default function InputField({
  className,
  ident,
  fieldRequired = false,
  inputType,
  value,
  name,
  onChange,
  options = [],
  pattern,
  placeholder,
  onBlur,
  min,
  max,
  maxLength,
  required = false,
}) {
  const dataListId = `${name}-datalist-options`;

  return (
    <div className={className || "input-space-default"}>
      <label htmlFor={name}>
        {ident}
        {(fieldRequired || required) && <span style={{ color: "red" }}>*</span>}
      </label>

      {/* Opção para renderizar um SELECT normal */}
      {inputType === "select" ? (
        <select
          id={name}
          name={name}
          value={value}
          onChange={onChange}
          required={required}
          onBlur={onBlur}
        >
          <option value="" disabled hidden>
            {placeholder || "Selecione"}
          </option>
          {Array.isArray(options) &&
            options.map((item, index) => {
              if (
                typeof item === "object" &&
                item.hasOwnProperty("value") &&
                item.hasOwnProperty("label")
              ) {
                return (
                  <option key={item.value} value={item.value}>
                    {item.label}
                  </option>
                );
              }
              if (typeof item === "object" && item.hasOwnProperty("id")) {
                const displayName = item.name || item.full_name || item.id;
                return (
                  <option key={item.id} value={item.id}>
                    {displayName}
                  </option>
                );
              }
              if (typeof item === "string" || typeof item === "number") {
                return (
                  <option key={item + "-" + index} value={item}>
                    {item}
                  </option>
                );
              }
              return null;
            })}
        </select>
      ) : /* ✨ NOVO: Opção para renderizar um INPUT PESQUISÁVEL */
      inputType === "datalist" ? (
        <>
          <input
            id={name}
            name={name}
            type="text"
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            onBlur={onBlur}
            required={required}
            maxLength={maxLength}
            list={dataListId} // Conecta o input com a lista de opções
            autoComplete="off" // Desativa o autocomplete do browser para não conflitar
          />
          <datalist id={dataListId}>
            {Array.isArray(options) &&
              options.map((item) => {
                // Para o datalist, o "value" da option é o texto que será exibido
                const displayLabel =
                  item.label || item.name || item.full_name || item.value;
                const itemKey = item.value || item.id;
                return <option key={itemKey} value={displayLabel} />;
              })}
          </datalist>
        </>
      ) : inputType === "textarea" ? (
        <textarea
          id={name}
          type={inputType}
          value={value}
          name={name}
          onChange={onChange}
          pattern={pattern}
          placeholder={placeholder}
          onBlur={onBlur}
          min={min}
          max={max}
          maxLength={maxLength}
          required={required}
        />
      ) : (
        /* Opção para renderizar um INPUT genérico */
        <input
          id={name}
          type={inputType}
          value={value}
          name={name}
          onChange={onChange}
          pattern={pattern}
          placeholder={placeholder}
          onBlur={onBlur}
          min={min}
          max={max}
          maxLength={maxLength}
          required={required}
        />
      )}
    </div>
  );
}
